// src/components/aiondemand/ScopeOption.jsx
//
// One row of a scope dropdown: the panel's Scope picker (AIOnDemandPanel) and
// the WellFinder report's County picker (ActionPreview) share it, so the two
// lists look and read the same in either theme.

export default function ScopeOption({ icon, label, meta, onClick, active }) {
    return (
        <button
            onClick={onClick}
            className={[
                "w-full flex items-center gap-2 px-3 py-2 text-xs text-left",
                "hover:bg-bg transition",
                active ? "text-accent-action" : "text-slate-300",
            ].join(" ")}
        >
            <span className="shrink-0 opacity-80">{icon}</span>
            <span className="flex-1 truncate font-medium">{label}</span>
            {meta && <span className="text-[10px] text-fg-secondary shrink-0">{meta}</span>}
        </button>
    );
}
